import React from 'react';
import { Input as BulmaInput } from 'react-bulma-components/lib/components/form';

import './style.scss';

export const Input = ({ color = null, ...props }) => (
  <BulmaInput color={color} {...props} />
);

export default Input;
